import { render, staticRenderFns } from "./on-register.vue?vue&type=template&id=c9fe4ba2&scoped=true"
import script from "./on-register.vue?vue&type=script&lang=js"
export * from "./on-register.vue?vue&type=script&lang=js"
import style0 from "./on-register.vue?vue&type=style&index=0&id=c9fe4ba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fe4ba2",
  null
  
)

export default component.exports